define('modules/player/media/local/modal/disconnect_last_zone_modal_view',[
  'backbone',
  'jquery',
  '_',
  'text!./disconnect_last_zone_modal_template.html'
], function (Backbone, $, _,
             modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      console.log('this.messageText', this.messageText);

      this.render();
    },

    tagName: 'div',
    className: 'disconnect-ad-modal',
    template: _.template(modal_template),

    events: {
      'click .js-confirm-button': 'disconnectAd'
    },

    render: function () {
      this.$el.html(this.template({'messageText': this.messageText}));
      return this;
    },

    disconnectAd: function (e) {
      e.preventDefault();
      this.trigger('disconnectAd');
      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

